"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateWeekBefore = dateWeekBefore;
exports.overrideTZ = overrideTZ;
exports.buildNow = buildNow;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
function dateWeekBefore() {
    return (0, moment_timezone_1.default)().subtract(7, 'd').toISOString();
}
function overrideTZ(date, TZ = 'Europe/London') {
    const timeFormat = 'YYYY-MM-DDTHH:mm:ss';
    const time = moment_timezone_1.default.parseZone(date);
    return moment_timezone_1.default.tz(time.format(timeFormat), TZ);
}
function buildNow(stubISOString, envVarName = 'STUB_TIME') {
    const envStubTime = global.env?.[envVarName];
    return () => {
        const stubTime = stubISOString || envStubTime;
        if (stubTime) {
            return (0, moment_timezone_1.default)(stubTime);
        }
        else {
            return (0, moment_timezone_1.default)();
        }
    };
}
